// PaymentExpiryTimer.tsx
import React, { useEffect, useRef, useState } from "react";

const PaymentExpiryTimer= ({
  onExpire,
  durationSeconds = 600,
  autoRestart = true,
  className = "",
}) => {
  const [secondsLeft, setSecondsLeft] = useState(durationSeconds);
  const intervalRef = useRef(null);

  // format as MM:SS
  const mmss = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    const mm = String(m).padStart(2, "0");
    const ss = String(sec).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  useEffect(() => {
    // clear just in case
    if (intervalRef.current) window.clearInterval(intervalRef.current);

    intervalRef.current = window.setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          // fire callback
          onExpire?.();
          // restart or stop at 0
          return autoRestart ? durationSeconds : 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (intervalRef.current) window.clearInterval(intervalRef.current);
    };
  }, [autoRestart, durationSeconds, onExpire]);

  // If you ever change durationSeconds prop on the fly, reset timer:
  useEffect(() => {
    setSecondsLeft(durationSeconds);
  }, [durationSeconds]);

  return (
    <div
      className={`flex items-center gap-2 text-sm md:text-base ${className}`}
      aria-live="polite"
    >
      <strong aria-label={`Time remaining ${mmss(secondsLeft)}`}>
        {mmss(secondsLeft)}
      </strong>
    </div>
  );
};

export default PaymentExpiryTimer;
